import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

export interface IFavoriteButtonDesktopProps {
  isFavorite: boolean;
  onClick?(): void;
}

export const FavoriteButtonDesktop: React.VFC<IFavoriteButtonDesktopProps> = ({ isFavorite, onClick }) => {
  const HeartIcon = isFavorite ? IconToggleHeartOn16 : IconToggleHeartOff16;

  return (
    <Button
      onClick={onClick}
      beforeIcon={<HeartIcon color="icon-negative-default" />}
      data-testid="FavoriteButtonDesktop"
      size="XS"
      theme="fill_secondary"
      type="button"
    >
      {isFavorite ? 'В избранном' : 'В избранное'}
    </Button>
  );
};
